"use strict";

exports.__esModule = true;
exports.processTagManagerQueueForGtm = exports.gtmFormatter = void 0;

const formatForGTM = (dataLayer, event) => {
  return { ...event,
    ...dataLayer,
    event: event.type,
    eventlabel: event.eventlabel,
    eventcategory: event.eventtype,
    eventaction: event.eventaction
  };
};

const formatEcommerceProductViewForGTM = event => {
  return {
    event: event.event,
    ecommerce: {
      impressions: event.products
    }
  };
};

const formatEcommerceProductClickForGTM = event => {
  return {
    event: event.event,
    ecommerce: {
      click: {
        products: event.products
      }
    }
  };
};

const formatEcommerceCheckoutForGTM = event => {
  return {
    event: event.event,
    ecommerce: {
      checkout: {
        actionField: {
          step: event.checkout_step
        },
        products: event.products
      }
    }
  };
};

const formatEcommerceCheckoutOptionForGTM = event => {
  return {
    type: event.type,
    event: event.event,
    ecommerce: {
      checkout_option: {
        actionField: {
          step: event.checkout_step,
          option: event.checkout_option
        }
      }
    }
  };
};

const formatEcommercePurchaseForGTM = event => {
  return {
    type: event.type,
    event: event.event,
    ecommerce: {
      purchase: {
        actionField: {
          id: event.order_id,
          affiliation: event.affiliation,
          revenue: event.revenue
        },
        products: event.products
      }
    }
  };
};

const formatEcommerceClear = () => {
  return {
    ecommerce: null
  };
};

const gtmFormatter = (dataLayer, genericEvent) => {
  let preparedMessage = formatForGTM(dataLayer, genericEvent);

  if (genericEvent.event === 'product_view') {
    preparedMessage = formatEcommerceProductViewForGTM(genericEvent);
  }

  if (genericEvent.event === 'product_click') {
    preparedMessage = formatEcommerceProductClickForGTM(genericEvent);
  }

  if (genericEvent.event === 'checkout') {
    preparedMessage = formatEcommerceCheckoutForGTM(genericEvent);
  }

  if (genericEvent.event === 'checkout_option') {
    preparedMessage = formatEcommerceCheckoutOptionForGTM(genericEvent);
  }

  if (genericEvent.event === 'purchase') {
    preparedMessage = formatEcommercePurchaseForGTM(genericEvent);
  }

  if (genericEvent.event === 'ecommerce_clear') {
    preparedMessage = formatEcommerceClear();
  }

  return preparedMessage;
};

exports.gtmFormatter = gtmFormatter;

const processTagManagerQueueForGtm = (tagManager, tagManagerQueue) => {
  if (tagManagerQueue.length > 0) {
    tagManagerQueue.map(event => event.type === 'pageview' ? tagManager.push({ ...window.dataLayer,
      event: event.type
    }) : event.type === 'event' ? tagManager.push({ ...window.dataLayer,
      event: event.type,
      eventlabel: event.eventlabel,
      eventaction: event.eventaction,
      eventcategory: event.eventtype
    }) : () => {});
  }
};

exports.processTagManagerQueueForGtm = processTagManagerQueueForGtm;